import { Info } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/** Marks a component that only renders in the internal staff console, never to a customer. */
export function ConsoleChip() {
  return (
    <Tooltip>
      {/* tabIndex makes the chip keyboard-reachable, since a Badge renders a non-focusable span. */}
      <TooltipTrigger asChild>
        <Badge tabIndex={0} className="bg-ink-100 text-ink-700 shrink-0 cursor-help gap-1.5">
          Console only
          <Info className="opacity-70" />
        </Badge>
      </TooltipTrigger>
      <TooltipContent>Only used in the internal staff console. Customers never see it.</TooltipContent>
    </Tooltip>
  )
}
